import React, { useCallback } from "react";
import { downloadCSV } from "../../helper/helpers";

const CSVLink = ({ data = "", filename = "sample.csv", children }) => {
  const onClick = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      downloadCSV(data, filename);
    },
    [data, filename]
  );
  return (
    <a href="#test" onClick={onClick} className="link">
      {children}
    </a>
  );
};
export default CSVLink;
